import { render, staticRenderFns } from "./OnDemandTraining.vue?vue&type=template&id=973a0720&scoped=true"
import script from "./OnDemandTraining.vue?vue&type=script&lang=js"
export * from "./OnDemandTraining.vue?vue&type=script&lang=js"
import style0 from "./OnDemandTraining.vue?vue&type=style&index=0&id=973a0720&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973a0720",
  null
  
)

export default component.exports